import { ButtonLink, EmptyState, EmptyStateIcons, Icon, IconButton, Icons, Search } from '@silverfort/sf-components';
import { httpGet } from '../../../../components/utils';
import { AD_ENTITY_TYPES, HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { useEffect, useState } from 'react';
import HostnameSelector from './components/HostnameSelector';

const AddHostnameResourceContainer = ({ resourceState, onAddResource, onClear, onDeleteResource }) => {
    const [lastRequestId, setLastRequestId] = useState(-1);
    const [fetchedHostname, setFetchedHostname] = useState([]);
    const [displayedHostname, setDisplayedHostname] = useState(resourceState.selectedHostnames);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleSelectorClose = () => {
        setFetchedHostname([]);
        setIsMenuOpen(false);
    };

    const handleSearch = (text) => {
        if (text) {
            setDisplayedHostname(resourceState.selectedHostnames.filter((hostname) => hostname.includes(text)));
        } else {
            setDisplayedHostname(resourceState.selectedHostnames);
        }
    };

    const onSelectHostname = (hostname) => {
        onAddResource(hostname);
    };

    const handleFetchHostnamesByText = async (text) => {
        const newRequestID = lastRequestId + 1;
        const reqUrl = `/users/searchEntitiesByTypes/${text}/${newRequestID}`;
        setLastRequestId(newRequestID);

        const response = await httpGet(reqUrl, {
            [HTTP_OPTIONS.REQ_OPTIONS]: {
                params: {
                    hideDeleted: true,
                    entitiesTypes: [AD_ENTITY_TYPES.HOST, AD_ENTITY_TYPES.SERVER],
                    authTypes: ['ad']
                }
            }
        });

        const hostnames = response.data.Results.map(({ name, guid }) => ({
            name,
            guid
        }));

        setFetchedHostname(hostnames);
    };

    useEffect(() => {
        setDisplayedHostname(resourceState.selectedHostnames);
    }, [resourceState.selectedHostnames]);

    return (
        <div className="flex flex-col border border-sf-gray-100 rounded-lg text-sf-gray-800 flex-1 overflow-auto">
            <div className="px-4 py-3 border-b border-b-sf-gray-100">
                <div className="flex flex-row flex-1 gap-1 justify-between items-center">
                    <span className="text-[13px] font-medium">{`Selected (${resourceState.selectedHostnames.length})`}</span>
                    <HostnameSelector
                        results={fetchedHostname}
                        selectHostnames={resourceState.selectedHostnames}
                        onSearch={handleFetchHostnamesByText}
                        onSelect={onSelectHostname}
                        onClose={handleSelectorClose}
                        isOpen={isMenuOpen}
                    />
                </div>
            </div>
            <div className="pl-2 pr-4 h-12 flex flex-row border-b border-b-sf-gray-100 justify-between items-center">
                <Search onChange={handleSearch} placeholder="Search by Hostname" />
                <ButtonLink className="text-[13px] font-normal" onClick={onClear} text="Clear All" underline />
            </div>

            <div className="p-4 flex flex-1 flex-col gap-2 overflow-auto">
                {resourceState.selectedHostnames.length === 0 ? (
                    <EmptyState
                        title="No resources added"
                        description="Search and add resources by clicking Add Resource"
                        actionText="Add Resource"
                        className="w-full h-full"
                        icon={EmptyStateIcons.NoItems}
                        onActionClick={() => setIsMenuOpen(true)}
                    />
                ) : (
                    displayedHostname.map((hostname, index) => (
                        <div key={index} className="flex flex-row justify-between items-center px-2">
                            <div className="flex flex-row gap-2 items-center">
                                <Icon className="text-sf-gray-400" icon={Icons.Server} size={16} />
                                <div className="flex flex-col">
                                    <span className="text-13">{hostname}</span>
                                    <span className="text-12 text-sf-gray-500">Host</span>
                                </div>
                            </div>
                            <IconButton icon={Icons.Cancel} iconSize={16} onClick={() => onDeleteResource(hostname)} />
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AddHostnameResourceContainer;
